import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private apiUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  // 🔔 System-wide notifications
  getAllNotifications() {
    return this.http.get(`${this.apiUrl}subs/Notification`);
  }

  postNotification(payload: any) {
    return this.http.post(`${this.apiUrl}subs/Notification`, payload);
  }

  // 👤 User-specific notifications
  getUserNotifications() {
    return this.http.get(`${this.apiUrl}subs/Usernotification`);
  }

  postUserNotification(payload: any) {
    return this.http.post(`${this.apiUrl}subs/Usernotification`, payload);
  }
}
